import {Box, Grid, Skeleton} from '@mui/material';
import styles from 'assets/jss/ProfileSkeleton';
import {makeStyles} from '@mui/styles';

const useStyles = makeStyles(styles);

const ProfileSkeleton = ({animation}) => {
    const classes = useStyles();
    return (
        <Box sx={{margin: '96px 24px 100px 24px'}}>
            {[...Array(1)].map((_,index) => (
                <Grid container className={classes.card} key={index}>
                    <Grid container className={classes.firstRow}  pb='30px'>
                        <Grid item xs={10} className={classes.centerlize}>
                            <Skeleton
                                variant="rectangular"
                                animation={animation}
                                sx={{borderRadius: '98px', width: '126px', height: '30px'}}
                            />
                        </Grid>
                        <Grid item xs={2} className={classes.selectBox}>
                            <Skeleton
                                variant="rectangular"
                                animation={animation}
                                sx={{borderRadius: '50%', width: '32px', height: '32px'}}
                            />
                        </Grid>
                    </Grid>
                    {[...Array(4)].map((_,index) => (
                        <Grid item xs={12} className={classes.centerlize} key={index}>
                            <Skeleton
                                animation={animation}
                                variant="h1"
                                sx={{borderRadius: '20px', width: '95%', mt: '1.2rem'}}
                            />

                        </Grid>
                    ))}


                </Grid>
            ))}
                <Skeleton
                    variant="rectangular"
                    animation={animation}
                    sx={{position:'absolute',left:"24px",borderRadius: '16px',
                        width: '90px', height: '45px',marginTop:'15px'}}
                />

        </Box>
    );
};

export default ProfileSkeleton
